const removeHtmlTags = (text) => text && text.replace(/<\/?[^>]+(>|$)|&nbsp;/g, '');
export default removeHtmlTags;
